import { useRef, useState, useEffect } from "react";
import "./Orders.css";
import { useDispatch, useSelector } from "react-redux";
import { selectDoctorId, selectUserId } from "../../Login/loginSlice";
import { getUserOrders, savePhotoOrder } from "./orderApi";
import { setOrders } from "./orderSlice";

function OrdersHeader({ doctorCompany, profession }) {
  const dispatch = useDispatch();
  const user_id = useSelector(selectUserId);
  const doctor_id = useSelector(selectDoctorId);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  const handleOpenModal = () => setIsModalOpen(true);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    stopCamera();
    setIsCameraOpen(false);
  };

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      streamRef.current = stream;
      setIsCameraOpen(true);
    } catch (err) {
      console.error("Ошибка доступа к камере:", err);
    }
  };

  // Подключаем поток к видео после открытия камеры
  useEffect(() => {
    if (isCameraOpen && videoRef.current && streamRef.current) {
      const video = videoRef.current;
      video.srcObject = streamRef.current;
      video.muted = true; // обязательно для autoplay
      video.playsInline = true; // для мобильных
      video.onloadedmetadata = () => {
        video.play().catch(console.error);
      };
    }
  }, [isCameraOpen]);

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
  };

  const takePhoto = () => {
    if (!videoRef.current) return;

    const video = videoRef.current;
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);

    canvas.toBlob(async (blob) => {
      if (blob) {
        const pars = { photo: blob, user_id, doctor_id };
        savePhotoOrder(pars, (data) => {
          console.log("Фото сохранено:", data);
          handleCloseModal();
          getUserOrders({ user_id, profession, doctor_id }, (data) => {
            if (data && data.orders) {
              dispatch(setOrders(data.orders));
            }
          });
        });
      }
    }, "image/jpeg", 0.8);
  };

  const handleChooseFile = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (file) {
        const pars = { photo: file, user_id, doctor_id };
        savePhotoOrder(pars, (data) => {
          console.log("Фото сохранено:", data);
          handleCloseModal();
          getUserOrders({ user_id, profession, doctor_id }, (data) => {
            if (data && data.orders) dispatch(setOrders(data.orders));
          });
        });
      }
    };
    input.click();
  };

  return (
    <>
      <div className="orders-header">
        <div className="orders-title-text">
          Заказы {doctorCompany ? `(${doctorCompany})` : ""}
        </div>
        <div className="orders-plus-icon" onClick={handleOpenModal}>
          +
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Создание заказа</h3>

            {!isCameraOpen ? (
              <div className="modal-buttons">
                <button className="modal-btn" onClick={startCamera}>
                  Сделать фото
                </button>
                <button className="modal-btn" onClick={handleChooseFile}>
                  Выбрать файл
                </button>
              </div>
            ) : (
              <div className="camera-wrapper">
                <video
                  ref={videoRef}
                  style={{ width: "100%", borderRadius: "4px" }}
                  autoPlay
                  muted
                  playsInline
                />
                <div
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  <button className="modal-btn" onClick={takePhoto}>
                    Снять фото
                  </button>
                  <button
                    className="modal-btn"
                    onClick={() => {
                      stopCamera();
                      setIsCameraOpen(false);
                    }}
                  >
                    Отмена
                  </button>
                </div>
              </div>
            )}

            <button className="modal-close" onClick={handleCloseModal}>
              ✖
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default OrdersHeader;
